export const Vto = {
    categoryCleanse: 'product_benefit_type_cleanse',
    categoryEyeCare: 'product_benefit_type_eye_care',
    categoryMoisturize: 'product_benefit_type_moisturize',
    categoryRepair: 'product_benefit_type_repair',
    categoryTreat: 'product_benefit_type_treat',
    categoryCream: 'product_benefit_type_cream',
    categorySerum: 'product_benefit_type_serum',
    categoryConcentrate: 'product_benefit_type_concentrate',
    vtoSkinCareButton: 'vto_skin_care_button',
    vtoSkinCareResultButton: 'vto_skin_care_result_button',
    skinCareResultTitle: 'vto_skin_care_result_title',
    skinCareStartOver: 'vto_skin_care_start_over'
};
